export const TECH_SUPPORT_SMB_EMAIL = 'tech-support@zamp.finance';
export const TECH_SUPPORT_TMS_EMAIL = 'tech-support+tms@zamp.finance';
